import { render, staticRenderFns } from "./ProfileTableItemValueStudentClasses.vue?vue&type=template&id=4637025e&scoped=true&"
import script from "./ProfileTableItemValueStudentClasses.vue?vue&type=script&lang=ts&"
export * from "./ProfileTableItemValueStudentClasses.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileTableItemValueStudentClasses.vue?vue&type=style&index=0&id=4637025e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4637025e",
  null
  
)

export default component.exports